import { Theme } from '@mui/material/styles'

import { Skin } from 'src/@core/layouts/types'
import { foundationTokens } from 'src/components/foundations'

const Drawer = (theme: Theme, skin: Skin) => ({
  MuiDrawer: {
    styleOverrides: {
      root: {
        '&.MuiModal-root .MuiDrawer-paper': {
          borderRadius: 0,
          boxShadow: theme.shadows[skin === 'bordered' ? 0 : foundationTokens.shadow.modal],
          ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
        }
      }
    }
  }
})

export default Drawer
